// src/utils/scheduleUtils.js
import moment from "moment";


export const convertToScheduleFormat = (WeeklyTimings) => {
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Initialize schedule with empty slot for each day
  let schedule = daysOfWeek.map((day) => ({
    day,
    checked: false,
    timeSlots: [{ from: "", to: "" }],
  }));

  if (Array.isArray(WeeklyTimings)) {
    WeeklyTimings.forEach((item) => {
      const dayIndex = schedule.findIndex((sch) => sch.day === item.dayName);
      if (dayIndex !== -1) {
        // Parse time with multiple format options and convert to 12-hour with AM/PM
        const openTime = moment(item.openTime, [
          "h:mm A",
          "hh:mm A",
          "h:mm a",
          "hh:mm a",
          "H:mm",
          "HH:mm",
        ], true);
        const closeTime = moment(item.closeTime, [
          "h:mm A",
          "hh:mm A",
          "h:mm a",
          "hh:mm a",
          "H:mm",
          "HH:mm",
        ], true);
        
        const formattedOpenTime = openTime.isValid() ? openTime.format("h:mm A") : item.openTime;
        const formattedCloseTime = closeTime.isValid() ? closeTime.format("h:mm A") : item.closeTime;

        // Replace the default empty slot with actual ones
        const timeSlot = {
          from: formattedOpenTime,
          to: formattedCloseTime,
        };

        if (
          schedule[dayIndex].timeSlots.length === 1 &&
          schedule[dayIndex].timeSlots[0].from === "" &&
          schedule[dayIndex].timeSlots[0].to === ""
        ) {
          schedule[dayIndex].timeSlots = [timeSlot];
        } else {
          schedule[dayIndex].timeSlots.push(timeSlot);
        }

        schedule[dayIndex].checked = true;
      }
    });
  }

  return schedule;
};


export const convertToScheduleFormatForProfile = (WeeklyTimings) => {
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Initialize schedule with empty slot for each day
  let schedule = daysOfWeek.map((day) => ({
    day,
    checked: false,
    timeSlots: [{ from: "", to: "", description: "" }],
  }));

  if (Array.isArray(WeeklyTimings)) {
    WeeklyTimings.forEach((item) => {
      const dayIndex = schedule.findIndex((sch) => sch.day === item.bD_DayName);
      if (dayIndex !== -1) {
        const formattedOpenTime = moment(item.bD_OpenTime, [
          "h:mm A",
          "HH:mm",
        ]).format("HH:mm");
        const formattedCloseTime = moment(item.bD_CloseTime, [
          "h:mm A",
          "HH:mm",
        ]).format("HH:mm");

        // Replace the default empty slot with actual ones
        const timeSlot = {
          from: formattedOpenTime,
          to: formattedCloseTime,
          description:item.bD_ServiceName
        };

        if (
          schedule[dayIndex].timeSlots.length === 1 &&
          schedule[dayIndex].timeSlots[0].from === "" &&
          schedule[dayIndex].timeSlots[0].to === ""
        ) {
          schedule[dayIndex].timeSlots = [timeSlot];
        } else {
          schedule[dayIndex].timeSlots.push(timeSlot);
        }

        schedule[dayIndex].checked = true;
      }
    });
  }

  return schedule;
};

export const checkIfCommonTimeSlots = (weeklyTimings) => {
  const allDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  if (!weeklyTimings || weeklyTimings.length <= 1) return false;

  // Group timings by day
  const dayGroups = {};
  allDays.forEach(day => {
    dayGroups[day] = []; // initialize all days with empty array
  });

  weeklyTimings.forEach(slot => {
    if (dayGroups[slot.dayName]) {
      dayGroups[slot.dayName].push({
        from: slot.openTime,
        to: slot.closeTime
      });
    }
  });

  const firstDay = allDays.find(day => dayGroups[day].length > 0);
  if (!firstDay) return true; // all days are empty

  const firstDaySlots = [...dayGroups[firstDay]].sort((a, b) =>
    a.from.localeCompare(b.from)
  );

  for (let i = 0; i < allDays.length; i++) {
    const currentDay = allDays[i];
    const currentSlots = [...dayGroups[currentDay]].sort((a, b) =>
      a.from.localeCompare(b.from)
    );

    if (currentSlots.length !== firstDaySlots.length) {
      return false;
    }

    for (let j = 0; j < currentSlots.length; j++) {
      if (
        currentSlots[j].from !== firstDaySlots[j].from ||
        currentSlots[j].to !== firstDaySlots[j].to
      ) {
        return false;
      }
    }
  }

  return true;
};



export const checkIfCommonTimeSlotsForProfile = (weeklyTimings) => {
  const allDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  if (!weeklyTimings || weeklyTimings.length <= 1) return false;

  // Group timings by day
  const dayGroups = {};
  allDays.forEach(day => {
    dayGroups[day] = []; // initialize all days with empty array
  });

  weeklyTimings.forEach(slot => {
    if (dayGroups[slot.bD_DayName]) {
      dayGroups[slot.bD_DayName].push({
        from: slot.bD_OpenTime,
        to: slot.bD_CloseTime,
        description: slot.bD_ServiceName
      });
    }
  });

  const firstDay = allDays.find(day => dayGroups[day].length > 0);
  if (!firstDay) return true; // all days are empty

  const firstDaySlots = [...dayGroups[firstDay]].sort((a, b) =>
    a.from.localeCompare(b.from)
  );

  for (let i = 0; i < allDays.length; i++) {
    const currentDay = allDays[i];
    const currentSlots = [...dayGroups[currentDay]].sort((a, b) =>
      a.from.localeCompare(b.from)
    );

    if (currentSlots.length !== firstDaySlots.length) {
      return false;
    }

    for (let j = 0; j < currentSlots.length; j++) {
      if (
        currentSlots[j].from !== firstDaySlots[j].from ||
        currentSlots[j].to !== firstDaySlots[j].to
      ) {
        return false;
      }
    }
  }

  return true;
};
